@import "/src/variables/font_size";
@import "/src/variables/color";
@import "/src/variables/font";
@import "/src/variables/tokens";

.hoverRow {
  display: flex;
  align-items: center;
  width: 100%;
  // The padding lives on .hoverRowMain so the whole row (not just the text)
  // is the click target.
  padding-right: $space-8;
  border-radius: $border-radius-sm;
  cursor: pointer;

  @media (hover: hover) and (pointer: fine) {
    &:hover {
      background-color: $zv-well--Neutral-Lightest;
    }

    &:hover .hoverMoreBtn {
      opacity: 1;
      pointer-events: auto;
    }
  }

  &.active {
    background-color: $zv-well--Neutral-Lightest;

    .hoverMoreBtn {
      opacity: 1;
      pointer-events: auto;
    }
  }

  // The conversation currently open in the chat panel.
  &.selected {
    background-color: $zv-highlight--Neutral-Lightest;

    .hoverRowText {
      font-weight: $font-weight-medium;
      color: $zv-text-primary--Neutral-Darkest;
    }
  }
}

.hoverRowMain {
  flex: 1 0 0;
  min-width: 0;
  align-self: stretch;
  border: none;
  outline: none;
  background: transparent;
  padding: $space-8;
  cursor: pointer;
  text-align: left;
}

.hoverRowText {
  display: block;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-family: $font-primary;
  font-weight: $font-weight-regular;
  font-size: $font-size-h14;
  line-height: $line-height-140-heading;
  color: $zv-text-primary--Neutral-Darker;
}

.hoverMoreBtn {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  border: none;
  outline: none;
  background: transparent;
  border-radius: $border-radius-round;
  cursor: pointer;
  color: $zv-icon--Neutral-Dark;
  opacity: 0;
  pointer-events: none;
  transition: opacity 150ms ease;

  @media (hover: none) {
    opacity: 1;
    pointer-events: auto;
  }
}

.emptyRow {
  padding: $space-8;
  font-family: $font-primary;
  font-weight: $font-weight-regular;
  font-size: $font-size-h14;
  line-height: $line-height-140-heading;
  color: $zv-text-primary--Neutral-Darker;
}

.embeddedMain {
  height: auto !important;
  min-height: 0 !important;
  padding: 0 !important;
  margin: 0 !important;
  animation: none !important;
}

.embeddedScroll {
  height: auto !important;
  max-height: none !important;
  overflow: visible !important;
}

.skeletonWrap {
  display: flex;
  flex-direction: column;
  padding-top: $space-8;
}

.skeletonGroup {
  display: flex;
  flex-direction: column;
  margin-bottom: $space-16;
}

.skeletonRow {
  padding: $space-8;
}
